module.exports = __webpack_public_path__ + "img/twitter-logo.a473618d.png";